import { render, staticRenderFns } from "./aterialmanagement.vue?vue&type=template&id=827efb22"
import script from "./aterialmanagement.vue?vue&type=script&lang=js"
export * from "./aterialmanagement.vue?vue&type=script&lang=js"
import style0 from "./aterialmanagement.vue?vue&type=style&index=0&id=827efb22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports